<template>
  <form @submit.prevent="$emit('submit')" class="fields-endpoint">
    <div class="flex flex-wrap md:flex-no-wrap md:gap-4">
      <div class="w-full md:w-1/2">
        <div class="form-group" :class="{ '-has-error': errors.organizationName.length > 0 }">
          <label for="organizationName" class="label">Nome da Empresa</label>
          <input
            type="text"
            id="organizationName"
            name="organizationName"
            class="form-control"
            required
            :value="form.organizationName"
            @input="updateFormField('organizationName', $event.target.value)"
          >

          <p class="description" v-if="errors.organizationName.length > 0">
            {{ errors.organizationName[0] }}
          </p>
        </div>
      </div>

      <div class="w-full md:w-1/2">
        <div class="form-group" :class="{ '-has-error': errors.cnpj.length > 0 }">
          <label for="cnpj" class="label">CNPJ</label>
          <input
            type="text"
            id="cnpj"
            name="cnpj"
            class="form-control"
            v-mask="'##.###.###/####-##'"
            required
            :value="form.cnpj"
            @input="updateFormField('cnpj', $event.target.value)"
          >

          <p class="description" v-if="errors.cnpj.length > 0">
            {{ errors.cnpj[0] }}
          </p>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap md:flex-no-wrap md:gap-4">
      <div class="w-full md:w-1/2">
        <div class="form-group" :class="{ '-has-error': errors.name.length > 0 }">
          <label for="name" class="label">Nome do Usuário</label>
          <input
            type="text"
            id="name"
            name="name"
            class="form-control"
            required
            :value="form.name"
            @input="updateFormField('name', $event.target.value)"
          >

          <p class="description" v-if="errors.name.length > 0">
            {{ errors.name[0] }}
          </p>
        </div>
      </div>

      <div class="w-full md:w-1/2">
        <div class="form-group" :class="{ '-has-error': errors.email.length > 0 }">
          <label for="email" class="label">Email</label>
          <input
            type="text"
            id="email"
            name="email"
            class="form-control"
            required
            :value="form.email"
            @input="updateFormField('email', $event.target.value)"
          >

          <p class="description" v-if="errors.email.length > 0">
            {{ errors.email[0] }}
          </p>
        </div>
      </div>
    </div>

    <div class="flex">
      <button class="btn btn-primary ml-auto" type="submit">{{ submitText }}</button>
    </div>
  </form>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'FormEndpoint',

  directives: {
    mask,
  },

  props: {
    form: {
      required: true,
      type: Object,
    },

    errors: {
      required: true,
      type: Object,
    },

    submitText: {
      required: false,
      type: String,
      default: 'Salvar',
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  methods: {
    /**
     * Update form field.
     *
     * @param field
     * @param value
     */
    updateFormField(field, value) {
      this.$emit('input', {
        ...this.form,
        [field]: value,
      });
    },
  },
};
</script>
